import { EditTagModal as SharedEditTagModal, type TagFormValues } from "@/components/ui/edit-tag-modal";
import { useTags } from "../hooks/use-tags";
import type { Tag } from "../types";

interface EditTagModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSuccess: () => void;
	workspaceId: string;
	tag: Tag | null;
}

export function EditTagModal({ open, onOpenChange, onSuccess, workspaceId, tag }: EditTagModalProps) {
	const { updateTag } = useTags();

	const handleSubmit = async (data: TagFormValues) => {
		if (!tag) {
			throw new Error("No tag selected for editing.");
		}

		const result = await updateTag(tag.id, workspaceId, data);
		if (!result) {
			throw new Error("Failed to update tag. Please try again.");
		}
	};

	return <SharedEditTagModal open={open} onOpenChange={onOpenChange} onSuccess={onSuccess} onSubmit={handleSubmit} tag={tag} />;
}
